import { IgUser } from '@core/models/ApiFields/ig-entities';
import { IDateRangeAsDates } from '@core/models/IDates';
import { IData } from '@core/models/IApi';
import { IG_ENDPOINT } from '../../social-listening/config/api-params';
import { HttpBuilder } from '../../social-shared/services/http/http-builder';
import { IgUserDetail } from '../../social-shared/store/ig-user-detail.store';
import { PageFiltersState } from '../../social-shared/store/page-filters.store';
import { userDetailFields } from '../config/user-detail.config';

export class UserDetailHttpBuilder extends HttpBuilder<IgUserDetail, IData> {
    reqData(state: IgUserDetail, pageFilters: PageFiltersState, igAcc: string) {
        const url = this.buildUrl(IG_ENDPOINT);
        const params = this.buildParams(pageFilters.selectedDates(), igAcc);

        state.isLoading.set(true);
        state.data.set([]);
        this.makeGetReq(url, params, state);
    }

    buildParams(dates: IDateRangeAsDates, igAcc: string) {
        return {
            ...this.getDates(dates),
            ...this.getFields(),
            ...this.getPagination(),
            ...this.getAccountFilter(igAcc),
        };
    }

    getFields() {
        return { fields: userDetailFields.join() };
    }

    getPagination() {
        return {
            limit: 20,
            offset: 0,
            mode: 1,
        };
    }

    getAccountFilter(igAcc: string) {
        return {
            [IgUser.getPrefixed('username')]: 'eq:' + igAcc,
        };
    }

    protected override handleSuccess(state: IgUserDetail, data: any): void {
        state.userData.set(data[0]);
    }
}
